import { render, staticRenderFns } from "./DoughnutAlertCard.vue?vue&type=template&id=4585157d&scoped=true&"
import script from "./DoughnutAlertCard.vue?vue&type=script&lang=js&"
export * from "./DoughnutAlertCard.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutAlertCard.vue?vue&type=style&index=0&id=4585157d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585157d",
  null
  
)

export default component.exports